import { createRoute } from "@tanstack/solid-router";
import { todosRoute } from "./todos";

export const allTodoRoute = createRoute({
  getParentRoute: () => todosRoute,
  path: "/todo/$todoId",
  component: AllTodoDetailRoutePage,
});

function AllTodoDetailRoutePage() {
  return null;
}
